module.exports = __webpack_public_path__ + "static/AngelaHe2-0c31f86f4ea256a99b1aa120e6c90bca.png";